import { Component } from '@angular/core';
import { ScenarioService } from '../services/scenario.service';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UserService } from '../auth/service/user.service';
import { PlayerSessionService } from '../services/player-session.service';
import { MediaService } from '../services/media.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { PublishedService } from '../services/published.service';
import { LibraryService } from '../services/library.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  environment = environment;
  scenarios: any;
  archivedScenarios: any;
  isLoading = false;
  userData: any;
  legacyScenarios: any;
  monthlyPlays: any = 0;
  bsModalRef?: BsModalRef;
  searchQuery = '';

  playLimit: any;
  scenarioLimit: any;
  currentUser: any = null;
  allMedia: any = null;
  monthlyAis: any = 0;

  aiCreditLimit: any;

  sort = 'modified';
  order = 'desc';
  sortTitles: any = {
    modified: 'Last updated',
    created: 'Date Created',
    title: 'Alphabetically',
  };

  viewMode = 'grid';
  viewStatus = 'active';
  showUiMsg = false;

  showMore = 0;
  perPage = 16;
  libraryItems: any = [];

  constructor(
    public scenarioService: ScenarioService,
    private router: Router,
    private modalService: BsModalService,
    private userService: UserService,
    private playerSessionService: PlayerSessionService,
    private mediaService: MediaService,
    private publishedService: PublishedService,
    private libraryService: LibraryService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;

    this.libraryService.fetchAll().subscribe((responseData) => {
      this.libraryItems = responseData;
      this.isLoading = false;
    });

    // unset scenario data
    this.scenarioService.data.next(null);
    this.playerSessionService
      .fetchMonthlyPlays(null, true)
      .subscribe((responseData: any) => {
        this.monthlyPlays = responseData[0].plays;
      });
  }

  getScenarios() {
    this.scenarioService.fetchAll().subscribe((responseData) => {
      this.scenarios = responseData;
      this.scenarios.forEach((scenario: any) => {
        if (scenario.scenario_data.style) {
          this.scenarioService.loadFonts(scenario.scenario_data);
        }
      });
      this.isLoading = false;
    });
  }

  onLoadScenario(scenario: any) {
    this.isLoading = true;
    this.scenarioService
      .fetch(scenario.scenario_id)
      .subscribe((responseData) => {
        this.scenarioService.setData(responseData.scenario_data);
        this.isLoading = false;
        this.router.navigate(['/steps', scenario.scenario_id]);
      });
  }

  getScenarioStyles(scenario: any) {
    return this.scenarioService.getScenarioStyles(scenario);
  }

  getScenarioCardStyle(scenario: any) {
    return this.scenarioService.getScenarioCardStyles(scenario);
  }

  getByStatus(scenarios: any, status: any, query?: string) {
    let returnScenarios = [];
    if (scenarios) {
      returnScenarios = scenarios.filter((scenario: any) => {
        return (
          scenario.status == status &&
          (!query ||
            (query &&
              scenario.title.toLowerCase().includes(query.toLowerCase())))
        );
      });

      // sort them
      if (this.order == 'desc') {
        returnScenarios.sort((a: any, b: any) => {
          // think about cases..
          let aValue = a[this.sort];
          let bValue = b[this.sort];
          if (this.sort == 'title') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }

          return aValue > bValue ? -1 : 1;
        });
      } else {
        returnScenarios.sort((a: any, b: any) => {
          // think about cases..
          let aValue = a[this.sort];
          let bValue = b[this.sort];
          if (this.sort == 'title') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }
          return aValue < bValue ? -1 : 1;
        });
      }
    }
    return returnScenarios;
  }

  searchLegacy(scenarios: any, query: string) {
    let returnScenarios = [];
    if (scenarios) {
      returnScenarios = scenarios.filter((scenario: any) => {
        return (
          !query ||
          (query && scenario.title.toLowerCase().includes(query.toLowerCase()))
        );
      });
    }

    return returnScenarios;
  }

  sortLegacy(scenarios: any) {
    // sort them
    if (this.order == 'desc') {
      scenarios.sort((a: any, b: any) => {
        // think about cases..
        let aValue = a[this.sort];
        let bValue = b[this.sort];
        if (this.sort == 'title') {
          aValue = aValue.toLowerCase();
          bValue = bValue.toLowerCase();
        }

        return aValue > bValue ? -1 : 1;
      });
    } else {
      scenarios.sort((a: any, b: any) => {
        // think about cases..
        let aValue = a[this.sort];
        let bValue = b[this.sort];
        if (this.sort == 'title') {
          aValue = aValue.toLowerCase();
          bValue = bValue.toLowerCase();
        }
        return aValue < bValue ? -1 : 1;
      });
    }
    return scenarios;
  }

  onUiMsgClosed() {
    this.showUiMsg = false;
    localStorage.setItem('showUiMsg', 'false');
  }

  onSetSortOrder(sort: string, order: string) {
    this.sort = sort;
    this.order = order;

    localStorage.setItem('ysDashSort', sort);
    localStorage.setItem('ysDashOrder', order);
  }

  onSetOrder(order: string) {
    this.order = order;
    localStorage.setItem('ysDashOrder', order);
  }
}
